import React, { useEffect, useContext, useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Button,
  Stack,
  Box,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { postRequest } from '../../../lib/api';
import { AuthContext } from '../../../authContext/context';
import Swal from 'sweetalert2';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import BreadcrumbsWrapper from '../../../components/breadcrumbs'


export const ViewSolicitors = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const [singleSolicitor, setSingleSolicitor] = useState(null);
  const [appointments, setAppointments] = useState([]);

useEffect(() => {
  const fetchSolicitorData = async () => {
    try {
      const response = await postRequest(`private/viewSolicitor/${id}`, {}, authCtx.token);
      if (response?.status === 200) {
        const solicitor = response?.data;
        setSingleSolicitor(solicitor);

        // 🧠 Map appointments for calendar
        if (Array.isArray(solicitor?.appointment_datetimes)) {
          const formattedAppointments = solicitor.appointment_datetimes.map((item) => ({
            id: item._id,
            title: item.customer_name || 'Appointment',
            date: item.appointment_datetime, // Should be ISO string
          }));
          setAppointments(formattedAppointments);
        }
      }
    } catch (err) {
      console.error('Error fetching solicitor:', err);
    }
  };

  fetchSolicitorData();
}, [id, authCtx.token]);


  const handleDelete = async () => {
    const confirm = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you really want to delete this solicitor?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    });

    if (confirm.isConfirmed) {
      try {
        const response = await postRequest(`private/deleteSolicitor/${id}`, {}, authCtx.token);
        if (response?.status === 200 || response?.success) {
          Swal.fire('Deleted!', 'Solicitor has been deleted.', 'success');
          navigate('/solicitors');
        } else {
          Swal.fire('Error', response?.message || 'Failed to delete solicitor', 'error');
        }
      } catch (err) {
        Swal.fire('Error', err?.message || 'Failed to delete solicitor', 'error');
      }
    }
  };

  return (
    <div style={{ padding: '20px' }}>
          <BreadcrumbsWrapper
                                        items={[
                                          { label: 'Dashboard', path: '/dashboard' },
                                          { label: 'Solicitors', path: '/solicitors' },
                                          { label: 'View Solicitor', path: '' },
                                         
                                        ]}
                                      />
                                <br></br>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <Typography variant="h4" gutterBottom>
          {singleSolicitor ? (
            <>
              {singleSolicitor?.forename}{' '}
              <span style={{ fontWeight: 300 }}>{singleSolicitor?.surname}</span>
            </>
          ) : (
            'Loading...'
          )}
        </Typography>

        <div>
          <Button variant="contained" color="error" size="small" onClick={handleDelete} style={{ marginRight: 8 }}>
            Delete
          </Button>
          <Button variant="outlined" size="small" onClick={() => navigate(`/solicitors/edit/${id}`)}>
            Edit
          </Button>
        </div>
      </div>

      <Stack direction="row" spacing={2} marginBottom={2}>
        <Button
          variant="outlined"
          sx={{
            color: '#bb0000',
            borderColor: '#bb0000',
            '&:hover': {
              borderColor: '#bb0000',
              backgroundColor: 'rgba(187, 0, 0, 0.04)',
            },
          }}
          onClick={() => navigate(`/reset-password/${id}`, { state: { key: 'solicitor' } })}
        >
          Reset Password
        </Button>
      </Stack>

      <Card variant="outlined" sx={{ marginBottom: 3 }}>
        <CardContent>
          <Stack spacing={2}>
            <Typography variant="body1">
              <strong>Username:</strong> {singleSolicitor?.username || '-'}
            </Typography>
            <Typography variant="body1">
              <strong>Email:</strong> {singleSolicitor?.email || '-'}
            </Typography>
            <Typography variant="body1">
              <strong>Phone:</strong> {singleSolicitor?.phone_number || '-'}
            </Typography>
          </Stack>
        </CardContent>
      </Card>

      {/* 📅 Calendar Section */}
      <Box sx={{ backgroundColor: '#fff', padding: 2, borderRadius: 2 }}>
        <Typography variant="h6" gutterBottom>
          Appointments
        </Typography>
        <FullCalendar
  plugins={[dayGridPlugin]}
  initialView="dayGridMonth"
  events={appointments} // contains { title: customer_name, date: datetime }
  height={500}
  headerToolbar={{
    left: 'prev,next today',
    center: 'title',
    right: '',
  }}
eventContent={(eventInfo) => {
  const dateObj = new Date(eventInfo.event.start);
  const formattedTime = dateObj.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <div
      style={{
        fontSize: '13px',
        padding: '4px 6px',
        backgroundColor: '#1976d2',
        color: 'white',
        borderRadius: '4px',
        border: 'none',
        textAlign: 'left',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {eventInfo.event.title} - {formattedTime}
    </div>
  );
}}

  dayCellContent={(arg) => (
    <div style={{ color: '#bb0000', fontWeight: 'bold' }}>
      {arg.dayNumberText}
    </div>
  )}
/>


      </Box>
    </div>
  );
};
